<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li>
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">Report Accumulation By Part Segment</li>
      </ol>
      <div class="row">
        <div class="col-md-4">
              <div class="form-group">
                <label>Part Select</label>
                <selectPartList 
                 :selectedOptionArray ="PartAlready"
                :remoteControl="'kspgAPI/ReportAccumulationBySegmentByPart/PartNumberSearch'" @selectedData="PartSelect"></selectPartList>              
            </div>
        </div>
        <div class="col-md-4">
              <div class="form-group">
                <label>Segment</label>
                <selectSegment
                :selectedOptionArray ="SegmentAlready"
                :remoteControl="'kspgAPI/ReportAccumulationBySegmentByPart/PartSegmentSearch'" @selectedData="SegmentSelect"></selectSegment>              

              </div>
          </div>
        <div class="col-md-4">
              <div class="form-group">
                <label>State Select</label>
                <selectState 
                 :selectedOptionArray ="StateAlready"
                :remoteControl="'kspgAPI/Part/PartnerStates'" @selectedData="StateSelect"></selectState>              
            </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="from">From Month</label>
          
          <datepicker :minimumView="'month'"   :name="'from'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="fromDateSelect" ></datepicker>
          </div>
        </div>
         <div class="col-md-3">
          <div class="form-group">
            <label for="To">To Month</label>
          <datepicker :minimumView="'month'" :value="newLastMonthDate" :name="'To'" :maximumView="'year'" :initialView="'year'" :bootstrapStyling="true" @selected="toDateSelect" ></datepicker>
          </div>
        </div>
      
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <label for="To">Search</label>
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
            <a target="_blank" v-on:click="download" class="btn btn-primary pull-right ">
  <span class="icon"><i class="material-icons">
                          get_app
                          </i></span> Export</a>
          </div>
          
        </div>
        <div v-if="file_url"><a :href="file_url">Download</a></div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Segment</th>
                    <th>Project</th>
                    <th>Point Accumulate</th>
                    <th>State</th>
                    <th>Year</th>
                    <th>Month</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in product_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.Segment }}</td>
                    <td>{{ item.Project }}</td>
                    <td>{{ item.Accumulate | removeNull}}</td>
                    <td>{{ item.State }}</td>
                    <td>{{ item.year }}</td>
                    <td>{{ item.month }}</td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'customerAccumulationPart.vue',
  data() {
    return {
      format:'MMM yyyy',
      fromMonthYear:'',
      toMonthYear:'',
      product_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message: '',
      newLastMonthDate:'',
      partSelected:'',
      PartAlready:{},
      StateAlready:{},
      SegmentAlready:{},
      stateSelected:'',
      segmentSelected:'',
      file_url:''
    };
  },
  components: {
    'Paginate':Paginate,
     selectState:() => import( '../components/Select2SearchWithTokenPrefetch.vue'),
     selectPartList: () => import('../components/Select2SearchWithTokenPrefetch.vue'),
     selectSegment: () => import('../components/Select2SearchWithTokenPrefetch.vue'),
    'Datepicker':Datepicker,
    
  },
  methods: {
    download(){
       const params = this.getRequestParams(
        this.searchText,
        0,
        this.pageSize
      );
       let loader = this.$loading.show();
      commonServices
        .get('kspgAPI/ReportAccumulationBySegmentByPart/exportReport', params)
        .then((response) => {
          if(response.data.status){
            this.file_url = response.data.file_url;
            this.SuccessMessage = response.data.message;
          }
          loader.hide()
        })
        .catch((e) => {
          if(e.response.data.error == "Invalid API key "){
            loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
        
    }
    ,
    fromDateSelect(date){
      this.fromMonthYear =date
    },
    toDateSelect(date){
      this.newLastMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toMonthYear =this.newLastMonthDate;
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};
      params['SegmentSelected'] = this.segmentSelected;
      params['PartSelected'] = this.partSelected;
      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }
      if(this.fromMonthYear){
        params['fromMonthYear'] = this.fromMonthYear;
      }
      if(this.toMonthYear){
        params['toMonthYear'] = this.toMonthYear;
      }     
      if(this.stateSelected){
        params['State'] = this.stateSelected;
      } 
      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/ReportAccumulationBySegmentByPart/list', params)
        .then((response) => {
          const {
            product_data,
            totalItems,
            currentPage,
            TotalPage,
         
          } = response.data;
          this.product_data = product_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
        
        })
        .catch((e) => {
           if(e.response.data.error == "Invalid API key "){
             loader.hide()
             this.$router.push({ name: 'login'});
          }
        });
      this.skyloEnd();
      setTimeout(() => {loader.hide()}, 2000)
    },
    PartSelect(val){
      this.partSelected =  val;
    },
    StateSelect(val){
      this.stateSelected = val;
    },
    SegmentSelect(val){
      this.segmentSelected = val;
    },
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
    removeNull(data) {
      if (!data) {
        return '0';
      }
      return data;
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align {
  text-align: left !important;
}
</style>